import { render, staticRenderFns } from "./fcNewsletterDetail.vue?vue&type=template&id=6b874607"
import script from "./fcNewsletterDetail.vue?vue&type=script&lang=js"
export * from "./fcNewsletterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports